import _asyncToGenerator from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/regenerator/index.js";
import React, { useEffect, useRef } from 'react';
import { loadScript } from '../../scripts/helpers';
import { trustpilotScriptUrl, trustpilotScriptId, trustPilotWidgetUrl } from '../../scripts/data';
var TrustpilotWidget = function TrustpilotWidget() {
  var trustBoxRef = useRef(null);
  useEffect(function () {
    var loadTrustpilot = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _t;
        return _regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              if (window.Trustpilot) {
                _context.next = 1;
                break;
              }
              _context.next = 1;
              return loadScript(trustpilotScriptUrl, trustpilotScriptId);
            case 1:
              if (trustBoxRef.current && window.Trustpilot) {
                window.Trustpilot.loadFromElement(trustBoxRef.current, true);
              }
              _context.next = 3;
              break;
            case 2:
              _context.prev = 2;
              _t = _context["catch"](0);
              console.error(_t);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 2]]);
      }));
      return function loadTrustpilot() {
        return _ref.apply(this, arguments);
      };
    }();
    loadTrustpilot();
  }, []);
  return React.createElement("a", {
    className: "trustpilot-outer position-relative my-5 my-lg-0 me-lg-4 d-table mx-auto",
    href: trustPilotWidgetUrl,
    target: "_blank",
    "data-link-both": "public-footer-trustpilot-widget",
    rel: "noopener noreferrer",
    title: "Trust Pilot Reviews",
    "aria-label": "Trust Pilot Reviews"
  }, React.createElement("div", {
    className: "trustpilot-widget",
    ref: trustBoxRef,
    "data-locale": "en-US",
    "data-template-id": "5419b757fa0340045cd0c938",
    "data-businessunit-id": "5513972d0000ff00057e4c5b",
    "data-style-height": "25px",
    "data-style-width": "180px"
  }));
};
export default TrustpilotWidget;